var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
var validate = ref.validate;
return [_vm._t("default",null,null,{ invalid: invalid }),_c('b-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit(validate, $event)}}},[_vm._t("submit",null,{"invalid":invalid})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }